/* eslint-disable linebreak-style */
// eslint-disable-next-line linebreak-style
/* eslint-disable max-len */
/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import { Typography, Paper, Button } from '@material-ui/core';
import { Group, ArrowForward } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';
import PresenceGraph from '../../../components/Graphics/PresenceGraph';
import { withStyles } from '@material-ui/core/styles';
import Star from '@material-ui/icons/Star';

const styles = theme => ({
  hover: {
    borderRadius: '1em',
    margin: ' 14px 4px',
    textAlign: 'center',
    width: '60%',
    color: '#537ccd',
    textTransform: 'none',
    marginRight: '2px',
    fontSize: '15px',
    fontWeight: 400,
    '&:hover': {
      color: '#6880c3',
      backgroundColor: '#f2b002',
    }
  }
});

class EventChart extends React.Component {
  state = {
    premium: JSON.parse(localStorage.getItem('privileges')).isExportAfd,
    premiumItem: false,
    defaultList: [],
    eventData: [],
    eventInfo: null,
    selectedSlice: null,
  };

  componentDidMount() {
    if (this.props.data) {
      this.fetchPresences();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.department !== this.props.department || prevProps.data !== this.props.data) {
      this.fetchPresences();
    }
  }

  onClickSlice = (sliceInfo) => {
    let newValue = null;

    if (sliceInfo.id !== this.state.selectedSlice) {
      newValue = sliceInfo.id;
    }

    this.setState({
      selectedSlice: newValue,
    }, () => {
      this.filterChart();
    });
  }

  setPieConfig = (list) => {
    let pointsOutOfPlace = 0;
    let pointsOffline = 0;
    let pointsDuplicate = 0;
    let pointsJustification = 0;


    list.forEach((eventData) => {
      if (eventData.typeEventId === 1) {
        pointsOutOfPlace = eventData.count;
      }
      else if (eventData.typeEventId === 2) {
        pointsOffline = eventData.count;
      }
      else if (eventData.typeEventId === 3) {
        pointsDuplicate = eventData.count;
      }
      else if (eventData.typeEventId === 4) {
        pointsJustification = eventData.count;
      } else { }
    });

    const infoConfig = [
      {
        id: 'Fora do Local', label: 'Fora do Local', value: pointsOutOfPlace, color: '#7BC6F1',
      },
      {
        id: 'Offline', label: 'Offline', value: pointsOffline, color: '#7BA9F1',
      },
      {
        id: 'Duplicado', label: 'Duplicado', value: pointsDuplicate, color: '#7B8BF1',
      },
      {
        id: 'Justificativa', label: 'Justificativa', value: pointsJustification, color: '#887BF1',
      },
    ];

    return infoConfig;
  }

  fetchPresences = () => {
    const response = this.props.data;
    let eventList = [];

    if (response && response.length > 0) {
      eventList = response.map(i => ({
        typeEventId: i.typeEventId,
        // department: i.employee.department,
      }));
    }

    // eventList = eventList.filter((employee) => {
    //   if (this.props.department > 0) {
    //     return employee.departmentId === this.props.department;
    //   }
    //   return employee;
    // });

    this.setState({
      defaultList: [...eventList],
      eventData: eventList,
      eventInfo: this.setPieConfig(response),
      selectedSlice: null,
    });
  }

  handleChangeHover = (status) => {
    if (!this.state.premium) {
      this.setState({
        premiumItem: status
      });
    }
  };

  render() {
    const { classes, data } = this.props;
    return (
      <Grid>
        <Paper elevation={2} style={{ flexBasis: '40%', margin: 'auto', marginTop: 'initial' }} className={classes.paperGraphics} data-tut="reactour__Faltantes">
          <Typography
            variant="h6"
            component="h4"
            color="textSecondary"
            align="left"
            style={{ padding: 20, fontColor: '#8898AA', fontSize: 15 }}
          >
            {' Central de Atividades - Divergências '}
          </Typography>

          <div
            style={{
              height: 300,
              //minWidth: 300,
              padding: '10px',
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              cursor: !this.state.eventData.length ? 'default' : 'pointer',
            }}
          >
            {
              !this.state.eventData.length ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Group color="disabled" style={{ fontSize: 100, paddingBottom: 20 }} />
                  <Typography component="h3" color="textSecondary" align="center">
                    Nenhuma divergência a ser exibida
                  </Typography>
                </div>
              ) :
                <PresenceGraph data={this.state.eventInfo} /*onClick={this.onClickSlice} selectedSlice={this.state.selectedSlice}*/ />
            }
          </div>
        </Paper>
        {!this.state.premiumItem ?
          <Paper
            style={{ display: 'flex', justifyContent: 'center' }}
            onMouseEnter={() => this.handleChangeHover(true)}
            onMouseLeave={() => this.handleChangeHover(false)}
          >
            <Button
              style={{ /*left: '280px', width: '100%',*/ height: '47px', width: '100%' }}
              component={Link}
              to="/central-de-atividades"
            >
              <Typography
                style={{
                  textTransform: 'none',
                  color: '#537ccd',
                  marginRight: '2px',
                  fontSize: '15px',
                  fontWeight: 400,
                }}>Ir para tela completa</Typography>
              <ArrowForward style={{ opacity: '0.6' }} />
            </Button>
          </Paper> :
          <Paper
            style={{ display: 'flex', justifyContent: 'center' }}
            onMouseEnter={() => this.handleChangeHover(true)}
            onMouseLeave={() => this.handleChangeHover(false)}
          >
            <Button
              style={{ height: '47px', width: '100%' }}
              component={Link}
              to='/assinatura'
            >
              <Star style={{ color: '#f2b002' }} />
              <Typography
                className={classes.hover}>
                Seja Premium para visualizar a tela completa
              </Typography>
            </Button>
          </Paper>
        }
      </Grid >
    );
  }
}

export default (withStyles(styles)(EventChart));